/**
 * Device type without forcing layout.
 *
 * `window.innerWidth` counts as a layout read: right after React changed the
 * DOM it makes the browser lay the whole page out synchronously (Chrome:
 * "forced reflow"). matchMedia answers the same question from the media state
 * without triggering a layout.
 */
export const getDeviceType = () => {
  if (window.matchMedia('(max-width: 767px)').matches) return 'mobile';
  if (window.matchMedia('(max-width: 1023px)').matches) return 'tablet';
  return 'desktop';
};

export default getDeviceType;